import * as RD from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from './cn.js';

/**
 * Right-hand detail drawer (docs/03 §26.1): opens OVER the queue so the
 * moderator keeps their place; closing returns to the same scroll position
 * (AC-ADM-20.5) because the list never unmounts.
 */
export function Drawer({
  open,
  onOpenChange,
  title,
  subtitle,
  children,
  footer,
  width = 'w-[560px]',
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  width?: string;
}) {
  return (
    <RD.Root open={open} onOpenChange={onOpenChange}>
      <RD.Portal>
        <RD.Overlay className="fixed inset-0 z-40 bg-navy-900/20" />
        <RD.Content
          className={cn(
            'fixed right-0 top-0 z-50 flex h-full flex-col border-l bg-white shadow-2xl focus:outline-none',
            width,
          )}
        >
          <div className="flex items-start justify-between border-b px-5 py-4">
            <div className="min-w-0">
              <RD.Title className="truncate text-base font-semibold text-grey-900">
                {title}
              </RD.Title>
              {subtitle && (
                <RD.Description className="mt-0.5 text-xs text-grey-500">{subtitle}</RD.Description>
              )}
            </div>
            <RD.Close
              className="rounded p-1 text-grey-500 hover:bg-grey-100 hover:text-grey-900"
              aria-label="Close drawer"
            >
              <X className="h-4 w-4" />
            </RD.Close>
          </div>
          <div className="min-h-0 flex-1 overflow-y-auto px-5 py-4">{children}</div>
          {footer && <div className="border-t bg-grey-100 px-5 py-3">{footer}</div>}
        </RD.Content>
      </RD.Portal>
    </RD.Root>
  );
}
